<template>
    <div>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "ATable"
    }
</script>

<style src="./Table.scss" lang="scss"></style>
